// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2Bxrq","messages":"Chat_messages__1GNfx","dateDivider":"Chat_dateDivider__2sEdf"};